<template>
  <b-modal
    size="xl"
    button-size="sm"
    ref="modal"
    hide-footer
    :id="this.id"
    :title="this.title"
    @show="this.openModal"
    @hidden="this.clearModal"
    @onselect="pessoaSelect"
    @onDblclicked="pessoaSelect"
  >
    <b-input-group class="col-sm-12 col-md">
      <b-form-input
        v-model="filter"
        variant="dark"
        :placeholder="placeholder"
        :disabled="busy"
        @keyup.enter="findFirstPage()"
      ></b-form-input>
      <div v-for="item in othersFilters" :key="item.name">
        <b-form-input
          style="border-radius: 0; border-left: 2px solid #ced4da"
          v-model="item.filter"
          v-if="item.disabled === false || item.disabled === undefined"
          variant="dark"
          :placeholder="item.placeholder"
          :disabled="busy"
          @keyup.enter="findFirstPage()"
        ></b-form-input>
      </div>
      <b-form-select
        v-if="filtrarSituacao"
        style="border-radius: 0; border-left: 2px solid #ced4da"
        v-model="situacao"
        variant="dark"
        placeholder="Situação"
        :options="optionsFilterSituacao"
        :disabled="busy"
        @change="findFirstPage()"
        class="form-control col-2"
      ></b-form-select>
      <b-input-group-addon append>
        <b-btn @click="load()">
          <b-icon icon="search" />
          <span class="d-none d-sm-inline ml-1">Buscar</span>
        </b-btn>
      </b-input-group-addon>
    </b-input-group>
    <b-table
      responsive="sm"
      :busy="this.busy"
      stacked="sm"
      small
      outlined
      sticky-header
      show-empty
      :items="this.records"
      :fields="this.fields"
      @row-clicked="this.rowSelect"
      @row-dblclicked="pessoaSelect"
    >
      <template #table-busy>
        <div class="text-center text-primary my-2">
          <b-spinner class="align-middle"></b-spinner>
        </div>
      </template>
      <template #empty>
        <h6 style="text-align: center">{{ tableEmptyText }}</h6>
      </template>
      <template #head()="data">
        <h6>{{ data.label.toUpperCase() }}</h6>
      </template>
      <template v-slot:cell(action)>
        <b-icon icon="arrow-down-left" class="mb-1" />
      </template>
    </b-table>
    <div class="row">
      <div class="h6 col-sm-6" style="display: flex; align-items: center">
        {{ pageText }}
      </div>
      <div class="col-sm-6">
        <b-pagination
          v-model="page"
          :per-page="perPage"
          :total-rows="total"
        ></b-pagination>
      </div>
    </div>
  </b-modal>
</template>
<!-- eslint-disable vue/no-unused-components -->

<script>
import ResourceService from "@/core/api/ResourceService";
import LgSearchBar from "@/core/components/LgSearchBar";

export default {
  components: {
    LgSearchBar,
  },
  props: {
    id: String,
    title: String,
    onDblclick: Function,
    url: String,
    ignoreInitialLoad: Boolean,
    fields: Array, // { key: String, label: String, thClass?: String, tdClass?: String }
    filterBy: {
      type: String,
      default: "descricao",
    },
    placeholder: {
      type: String,
      default: "Informe um valor e pressione enter",
    },
    othersFilters: {
      type: Array,
      default: () => [],
    },
    onlyActivies: {
      type: Boolean,
      default: false,
    },
    filtrarSituacao: {
      type: Boolean,
      default: false,
    },
    pessoaSelect: {
      type: Function,
      default: () => {},

    }
  },
  data() {
    return {
      records: [],
      filter: "",
      page: 1,
      total: 0,
      totalPage: 0,
      perPage: 10,
      untouched: true,
      busy: false,
      situacao: "1",
      optionsFilterSituacao: [
        { key: "filterSituacao", text: "Todos", value: undefined },
        { key: "filterSituacao", text: "Ativo", value: "1" },
        { key: "filterSituacao", text: "Inativo", value: "0" },
      ],
    };
  },
  mounted() {
    this.$service = new ResourceService(this.url);
    this.busy = true;
    this.load();
  },
  watch: {
    page() {
      this.load();
    },
  },
  computed: {
    tableEmptyText() {
      if (this.ignoreInitialLoad && this.untouched) {
        return "Informe um valor para busca";
      }

      return "Nenhum registro encontrado";
    },
    pageText() {
      return this.totalPage > 0
        ? `Página ${this.page} de ${this.totalPage} - ${this.total} registros`
        : "";
    },
  },
  methods: {
    async findFirstPage() {
      this.page = 1;
      await this.load();
    },
    async load() {
      if (this.busy) {
        return;
      }
      this.busy = true;

      let filters = "";

      if (this.filter) {
        filters += `${this.filterBy}:>${this.filter},`;
      }
      if (this.othersFilters.length) {
        this.othersFilters.forEach((item) => {
          let itemTemp = {
            ...item,
          };
          if (itemTemp.action) {
            itemTemp = itemTemp.action(itemTemp);
          }
          if (itemTemp.filter) {
            let operator = itemTemp.operator || ":>";
            filters += `${itemTemp.field}${operator}${itemTemp.filter},`;
          }
        });
      }
      if (this.onlyActivies) {
        filters += "situacao::1";
      } else if (this.filtrarSituacao && this.situacao) {
        filters += `situacao::${this.situacao}`;
      }
      const { data } = await this.$service.findAll({
        limit: this.perPage,
        page: this.page,
        filter: filters,
      });

      this.untouched = true;
      this.records = await data.content;
      this.total = await data.totalElements;
      this.totalPage = (await data.totalPages) || 1;
      this.page = (await data.pageable.pageNumber) + 1;
      this.busy = false;
    },

    async openModal() {
      this.clearModal();

      if (!this.ignoreInitialLoad) {
        await this.load();
      }
    },
    async clearModal() {
      this.filter = "";
      this.untouched = false;
      this.records = [];
      this.total = 0;
      this.totalPage = 0;
      this.page = 1;
      this.busy = false;
    },
    async rowSelect(item) {
      this.$emit("onSelect", item);
      this.$bvModal.hide(this.id);
    },
    async show() {
      this.$bvModal.show(this.id);
    },
  },
};
</script>

<style scoped>
.loader {
  text-align: center;
  color: #bbbbbb;
}
</style>
